/* eslint-disable no-undef */

/* eslint-disable no-unused-vars */
var fundraiserSlider = new Swiper('#fundraiserSlider', {
  // loop: true,
  slidesPerView: 1,
  breakpoints: {
    // when window width is >= 320px
    560: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 640px
    768: {
      slidesPerView: 3,
      spaceBetween: 30
    }
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  }
});